const e=({headline:e,modelCode:n,brand:o="",subBrand:d=""})=>({currentHeadLine:e||[o,d].filter(Boolean).join(" "),currentModelCode:n??""});export{e as getProductHeadlineAndModelCode};
